import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('partCkuPrvsStore', Object.keys(state)),
	...mapGetters('partCkuPrvsStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('partCkuPrvsStore', Object.keys(actions)),
	...mapMutations('partCkuPrvsStore', Object.keys(mutations))
};
